import React, { FunctionComponent } from "react";
import { shallowEqual, useSelector } from "react-redux";

import {
    DigitalShareAppImage,
    DigitalShareAppType
} from "../../../../Enums/DigitalShareAppType";
import { IUser } from "../../../../Models/IUser";
import { IUserShareSettings } from "../../../../Models/IUserShareSettings";
import {
    userSelector,
    userShareSettingsSelector
} from "../../../../Reducers/Selectors/UserSelectors";
import {
    BrandLogo,
    BuxtonLogoAppName,
    BuxtonLogoWrapper,
    ContactImage,
    ContactInfo, Content,
    Disclaimer,
    Footer,
    FooterFlexContent,
    Header,
    SectionTitle,
    SectionTitleCaption,
    SectionTitleWrapper,
    Template
} from "./TemplateStyles";

export interface IDigitalShareTemplateProps {
    appName: DigitalShareAppType;
    sectionTitle: string;
    children: React.ReactNode;
    captionAboveTitle?: string;
}

const logoMap: Map<string, JSX.Element> = new Map();

for (const app in DigitalShareAppType) {
    logoMap.set(
        DigitalShareAppType[app],
        <img
            data-testid={`digishare-template-buxton-logo-appname`}
            width="136px"
            style={{ transform: "translateY(-3px)" }}
            src={DigitalShareAppImage[app]}
        />
    );
}

const DigitalShareTemplate: FunctionComponent<IDigitalShareTemplateProps> = (
    props: IDigitalShareTemplateProps
) => {
    const user: IUser = useSelector(userSelector);
    const shareSettings: IUserShareSettings = useSelector(
        userShareSettingsSelector,
        shallowEqual
    );
    const userFullName = `${user.firstName} ${user.lastName}`;
    const phone: string = user.phone;
    const disclaimer: string = shareSettings?.disclaimer;

    return (
        <Template data-testid="digital-share-template">
            <Header>
                <BuxtonLogoWrapper>
                    <img
                        width="136px"
                        src="/Images/NEW_UI/rebrand/png/small/Buxton-Blue_Small.png"
                    />
                    <BuxtonLogoAppName>{logoMap.get(props.appName)}</BuxtonLogoAppName>
                </BuxtonLogoWrapper>
                <SectionTitleWrapper>
                    <SectionTitleCaption>{props.captionAboveTitle}</SectionTitleCaption>
                    <SectionTitle>{props.sectionTitle}</SectionTitle>
                </SectionTitleWrapper>
            </Header>
            <Content>{props.children}</Content>
            <Footer>
                <FooterFlexContent>
                    {user.shareImage && (
                        <BrandLogo>
                            <img
                                src={`/Images/Users/Share/${user.shareImage}`}
                                style={{
                                    width: "100%",
                                    height: 55
                                }} />
                        </BrandLogo>
                    )}
                    <Disclaimer>{disclaimer}</Disclaimer>
                    <ContactInfo>
                        <div className="contact-info-name">{userFullName}</div>
                        <div className="contact-info-email">{user.email}</div>
                        {phone && <div className="contact-info-phone">{phone}</div>}
                    </ContactInfo>
                    {user.profileImage && (
                        <ContactImage>
                            <img src={`/Images/Users/Avatars/${user.profileImage}`} />
                        </ContactImage>
                    )}
                </FooterFlexContent>
            </Footer>
        </Template>
    );
};
export default DigitalShareTemplate;
